export const VCF_UPLOAD_NOTIFICATION_MESSAGES = {
  FILE_REQUIRED: 'Please select a VCF file before uploading.',
  UPLOAD_STARTED: 'VCF upload started.',
  UPLOAD_FAILED: 'The VCF upload could not be started.',
  VARVIS_FILE_REQUIRED:
    'Please select a Varvis CSV or XLSX file before uploading.',
  VARVIS_UPLOAD_STARTED: 'Varvis upload started.',
  VARVIS_UPLOAD_FAILED: 'The Varvis upload could not be started.',
} as const;
